import React, { Component } from 'react';
import styles from './carListIpempanel.module.scss';
// import styles from "../carsListItem.module.scss";
import { withRoutes } from '../../../../shared/containers/containerRoutes';
import { withCompanyGroups } from '../../../../shared/containers/containerCompanyGroups';
import { withUnits } from '../../../../shared/containers/containerUnits';
import { withGeozones } from '../../../../shared/containers/geozonesContainer';
import { withChoosedCar } from '../../../../shared/containers/containerChoosedCar';
import { withMainMap } from '../../../../shared/containers/containerMainMap';
import { withMapControl } from '../../../../shared/containers/containerMapControl';
import { withRouter } from 'react-router-dom/cjs/react-router-dom.min';
import { getCarsTypeName } from '../static.carsTypes';
import { Link } from 'react-router-dom';
import SettingsIcon from '@mui/icons-material/Settings';
import RoomIcon from '@mui/icons-material/Room';
import TooltipWrapper from './../../../../shared/items/contols/tooltipWrapper';

import StarBorderIcon from '@mui/icons-material/StarBorder';
import StarIcon from '@mui/icons-material/Star';
import KeyIcon from '@mui/icons-material/Key';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import LocalGasStationIcon from '@mui/icons-material/LocalGasStation';
import GasMeterIcon from '@mui/icons-material/GasMeter';
import AcUnitIcon from '@mui/icons-material/AcUnit';
import SettingsInputComponentIcon from '@mui/icons-material/SettingsInputComponent';
import ScatterPlotIcon from '@mui/icons-material/ScatterPlot';
import DeviceThermostatIcon from '@mui/icons-material/DeviceThermostat';
import AddRoadIcon from '@mui/icons-material/AddRoad';
import DeviceHubIcon from '@mui/icons-material/DeviceHub';
import VideocamIcon from '@mui/icons-material/Videocam';
import VideocamOffIcon from '@mui/icons-material/VideocamOff';

import { withSetCarBookmark } from '../../../../shared/containers/containerSetCarBookmark';
import { withDeleteCarBookmark } from '../../../../shared/containers/containerDeleteCarBookmark';
import getDates from '../../../../shared/services/date.service';
import { withVideoTools } from '../../../../shared/containers/containerVideoTools';

const muiIconStyle = {
  width: '18px',
};

const FUELE1 = 'FUELE1';
const FUELE2 = 'FUELE2';
const FUELE3 = 'FUELE3';
const FUEF = 'FUEF';
const FUEAMO = 'FUEAMO';
const DU1 = 'DU1';
const DU2 = 'DU2';
const SAND = 'SAND';
const QUI = 'QUI';
const TE = 'TE';
const DISSE = 'DISSE';
const FUALLS = 'FUALLS';

class CarListItemPanel extends Component {
  componentDidMount() {
    const { handleScrollTo, match, data } = this.props;

    if (
      match.params.id === data.id &&
      document.querySelectorAll(`.opened_container_carsListItem`)[0]
    )
      handleScrollTo(
        document.querySelectorAll(`.opened_container_carsListItem`)[0]
          .offsetTop,
      );
  }

  onBookmark() {
    const { data, onSetCarBookmark, onDeleteCarBookmark } = this.props;

    if (data.isBookmark) {
      onDeleteCarBookmark(data.id);
    } else {
      onSetCarBookmark(data.id);
    }
  }

  onMapCenter(offset = 0) {
    const { data, onSetMapCenter, onSetZoom } = this.props;

    onSetMapCenter({
      lat: data.lastLocation.lat,
      lng: data.lastLocation.long - offset,
    });
    onSetZoom(15);
  }

  onChooseCar() {
    const { data, onChooseCar, onSetStateVideoPanel, speedPlay, deviceId } =
      this.props;

    onChooseCar(data);
    this.onMapCenter();

    if (
      data.howenDevice === null ||
      !data.howenDevice.isOnline ||
      (deviceId !== null && data.howenDevice.otherId !== deviceId)
    ) {
      onSetStateVideoPanel(false, null, null, true, null, null, speedPlay);
    }
  }

  setStateVideoPanel() {
    const { onSetStateVideoPanel, data, deviceId, speedPlay } = this.props;

    if (data.howenDevice === null || !data.howenDevice.isOnline) {
      onSetStateVideoPanel(false, null, null, true, null, null, speedPlay);
      return;
    }

    if (data.howenDevice !== null && data.howenDevice.otherId === deviceId)
      return;

    onSetStateVideoPanel(
      true,
      data.howenDevice.otherId,
      data.howenDevice.channels,
      true,
      null,
      null,
      speedPlay,
    );
  }

  render() {
    const { data, choosedCarId } = this.props;
    const isSelect = choosedCarId === data.id;

    const isCanSensor = Object.keys(data.sensors).some((x) => {
      return x.includes('CAN');
    });

    let mobileOpertor = '';

    if (
      data.devices[0].numberSim !== null &&
      data.devices[0].numberSim.length === 19
    ) {
      mobileOpertor = 'A1';
    }

    if (
      data.devices[0].numberSim !== null &&
      data.devices[0].numberSim.length === 20
    ) {
      mobileOpertor = 'МТС';
    }

    return (
      <div className={styles.carsListItemWrapper}>
        <div className={styles.container_carsListItemWrapper}>
          <Link
            className={styles.linkWrapper}
            to={`/cars/${data.id}/intimerange`}
            onClick={(e) => {
              /*               e.stopPropagation(); */
              this.onChooseCar();
            }}
          >
            <div
              className={styles.carsListItem}
              onClick={(e) => {
                this.onChooseCar();
              }}
            >
              <div className={getStatusStyles(data)}>
                <span className={styles.title}>{data.number}</span>
              </div>

              <div>
                <div className={styles.carsListItemTitle}>
                  {data.unit.title}
                </div>

                <div className={styles.dashboardPanelContainer}>
                  <div>{data.unit.registerNumber}</div>

                  <div className={styles.dashboardPanel}>
                    {!data.gpsSignal ? (
                      <TooltipWrapper
                        title={'Ошибка данных GPS'}
                        position="top"
                      >
                        <div className={styles.dashboardPanelItem}>
                          <WarningAmberIcon
                            style={{ ...muiIconStyle, color: '#ff626c' }}
                          />
                        </div>
                      </TooltipWrapper>
                    ) : null}

                    {isCanSensor ? (
                      <TooltipWrapper title={'CAN-шина'} position="top">
                        <div className={styles.dashboardPanelItem}>
                          <DeviceHubIcon style={muiIconStyle} />
                        </div>
                      </TooltipWrapper>
                    ) : null}

                    {data.sensors[DISSE] !== undefined ? (
                      <TooltipWrapper
                        title={data.sensors[DISSE]}
                        position="top"
                      >
                        <div className={styles.dashboardPanelItem}>
                          <AddRoadIcon style={muiIconStyle} />
                        </div>
                      </TooltipWrapper>
                    ) : null}

                    {data.sensors[TE] !== undefined ? (
                      <TooltipWrapper title={data.sensors[TE]} position="top">
                        <div className={styles.dashboardPanelItem}>
                          <DeviceThermostatIcon style={muiIconStyle} />
                        </div>
                      </TooltipWrapper>
                    ) : null}

                    {data.sensors[SAND] !== undefined ? (
                      <TooltipWrapper title={data.sensors[SAND]} position="top">
                        <div className={styles.dashboardPanelItem}>
                          <ScatterPlotIcon style={muiIconStyle} />
                        </div>
                      </TooltipWrapper>
                    ) : null}

                    {data.sensors[DU1] !== undefined ? (
                      <TooltipWrapper title={data.sensors[DU1]} position="top">
                        <div className={styles.dashboardPanelItem}>
                          <AcUnitIcon style={muiIconStyle} />
                        </div>
                      </TooltipWrapper>
                    ) : null}

                    {data.sensors[DU2] !== undefined ? (
                      <TooltipWrapper title={data.sensors[DU2]} position="top">
                        <div className={styles.dashboardPanelItem}>
                          <AcUnitIcon style={muiIconStyle} />
                        </div>
                      </TooltipWrapper>
                    ) : null}

                    {data.sensors[FUEF] !== undefined ? (
                      <TooltipWrapper title={data.sensors[FUEF]} position="top">
                        <div className={styles.dashboardPanelItem}>
                          <GasMeterIcon style={muiIconStyle} />
                        </div>
                      </TooltipWrapper>
                    ) : null}

                    {data.sensors[FUALLS] !== undefined ? (
                      <TooltipWrapper
                        title={data.sensors[FUALLS]}
                        position="top"
                      >
                        <div className={styles.dashboardPanelItem}>
                          <GasMeterIcon style={muiIconStyle} />
                        </div>
                      </TooltipWrapper>
                    ) : null}

                    {data.sensors[FUEAMO] !== undefined ? (
                      <TooltipWrapper
                        title={data.sensors[FUEAMO]}
                        position="top"
                      >
                        <div className={styles.dashboardPanelItem}>
                          <GasMeterIcon style={muiIconStyle} />
                        </div>
                      </TooltipWrapper>
                    ) : null}

                    {data.sensors[QUI] !== undefined ? (
                      <TooltipWrapper title={data.sensors[QUI]} position="top">
                        <div className={styles.dashboardPanelItem}>
                          <SettingsInputComponentIcon style={muiIconStyle} />
                        </div>
                      </TooltipWrapper>
                    ) : null}

                    {data.sensors[FUELE1] !== undefined ? (
                      <TooltipWrapper
                        title={data.sensors[FUELE1]}
                        position="top"
                      >
                        <div className={styles.dashboardPanelItem}>
                          <LocalGasStationIcon style={muiIconStyle} />
                        </div>
                      </TooltipWrapper>
                    ) : null}

                    {data.sensors[FUELE2] !== undefined ? (
                      <TooltipWrapper
                        title={data.sensors[FUELE2]}
                        position="top"
                      >
                        <div className={styles.dashboardPanelItem}>
                          <LocalGasStationIcon style={muiIconStyle} />
                        </div>
                      </TooltipWrapper>
                    ) : null}

                    {data.sensors[FUELE3] !== undefined ? (
                      <TooltipWrapper
                        title={data.sensors[FUELE3]}
                        position="top"
                      >
                        <div className={styles.dashboardPanelItem}>
                          <LocalGasStationIcon style={muiIconStyle} />
                        </div>
                      </TooltipWrapper>
                    ) : null}

                    {data.howenDevice !== null ? (
                      <TooltipWrapper
                        title={
                          data.howenDevice.isOnline
                            ? 'Онлайн видео доступно к просмотру'
                            : 'Онлайн видео не доступно к просмотру'
                        }
                        position="top"
                      >
                        <div
                          className={styles.dashboardPanelItem}
                          onClick={this.setStateVideoPanel.bind(this)}
                        >
                          {data.howenDevice.isOnline ? (
                            <VideocamIcon
                              style={{ ...muiIconStyle, color: '#54cb64' }}
                            />
                          ) : (
                            <VideocamOffIcon style={muiIconStyle} />
                          )}
                        </div>
                      </TooltipWrapper>
                    ) : null}

                    <TooltipWrapper
                      title={
                        data.ignition
                          ? 'Зажигание включено'
                          : 'Зажигание выключено'
                      }
                      position="top"
                    >
                      <div className={styles.dashboardPanelItem}>
                        {data.ignition ? (
                          <KeyIcon
                            style={{ ...muiIconStyle, color: '#f7bf47' }}
                          />
                        ) : (
                          <KeyIcon style={muiIconStyle} />
                        )}
                      </div>
                    </TooltipWrapper>

                    <TooltipWrapper
                      title={
                        data.isBookmark
                          ? 'Убрать из избранного'
                          : 'Добавить в избранное'
                      }
                      position="top"
                    >
                      <div
                        className={styles.dashboardPanelItem}
                        onClick={(e) => {
                          e.stopPropagation();
                          e.preventDefault();
                          this.onBookmark();
                        }}
                      >
                        {data.isBookmark ? (
                          <StarIcon
                            style={{ ...muiIconStyle, color: '#f7bf47' }}
                          />
                        ) : (
                          <StarBorderIcon style={muiIconStyle} />
                        )}
                      </div>
                    </TooltipWrapper>

                    <TooltipWrapper
                      title={'Показать в центре карты'}
                      position="top"
                    >
                      <div
                        className={styles.dashboardPanelItem}
                        onClick={(e) => {
                          e.stopPropagation();
                          e.preventDefault();
                          if (choosedCarId === null) this.onMapCenter();
                        }}
                      >
                        {choosedCarId !== null ? (
                          <RoomIcon
                            style={{ ...muiIconStyle, color: '#d0d0d0' }}
                          />
                        ) : (
                          <RoomIcon style={muiIconStyle} />
                        )}
                      </div>
                    </TooltipWrapper>

                    <TooltipWrapper title={'Открыть настройки'} position="top">
                      <div
                        onClick={(e) => {
                          e.stopPropagation();
                        }}
                      >
                        <a
                          className={styles.dashboardPanelItem}
                          target="_blank"
                          href={`/cars/${data.id}/settings`}
                          rel="noreferrer"
                        >
                          <SettingsIcon style={muiIconStyle} />
                        </a>
                      </div>
                    </TooltipWrapper>
                  </div>
                </div>
              </div>
            </div>
          </Link>
        </div>
        {isSelect ? (
          <div className={getStatusStyles(data)}>
            <div className={styles.mDCarItem}>
              <span className={styles.mDCarItemTitle}>
                IMEI: {data.devices[0].imei}
              </span>
              <span className={styles.mDCarItemTitle}>
                ICCID: {data.devices[0].numberSim} {mobileOpertor}
              </span>
            </div>

            {data.drivers.length > 0 ? (
              <div className={styles.mDCarItem}>
                <span className={styles.mDCarItemContent}>Водитель (-и):</span>

                {data.drivers.map((driver) => {
                  return (
                    <div>
                      <span className={styles.mDCarItemTitle}>
                        {driver.lastName} {driver.firstName} {driver.middleName}
                      </span>
                    </div>
                  );
                })}
              </div>
            ) : null}

            <div className={styles.mDCarItem}>
              <span className={styles.mDCarItemTitle}>
                Последняя активность
              </span>
              <span className={styles.mDCarItemContent}>
                {getDates.getDateFormat4(data.lastActive)}
              </span>
            </div>
            {data.unit.groups.length > 0 ? (
              <div className={styles.mDCarItem}>
                <span className={styles.mDCarItemTitle}>Группы</span>
                <span className={styles.mDCarItemContent}>
                  {data.unit.groups.map((item) => (
                    <div key={item.id}>{item.title}</div>
                  ))}
                </span>
              </div>
            ) : null}
          </div>
        ) : null}
      </div>
    );
  }
}

const getStatusStyles = (data) => {
  switch (
    data.unit.inActive === true ? 'inActive' : getCarsTypeName(data.status.id)
  ) {
    case 'noData':
      return styles.container_carNumber_noData;
    case 'inMove':
      return styles.container_carNumber_inMove;
    case 'parking':
      return styles.container_carNumber_parking;
    case 'inActive':
      return styles.container_carNumber_inActive;
    default:
      return null;
  }
};

export default withVideoTools(
  withRoutes(
    withSetCarBookmark(
      withDeleteCarBookmark(
        withCompanyGroups(
          withUnits(
            withGeozones(
              withChoosedCar(
                withMainMap(
                  withMapControl(withRouter(React.memo(CarListItemPanel))),
                ),
              ),
            ),
          ),
        ),
      ),
    ),
  ),
);
